import PropTypes from "prop-types"
import intl from 'react-intl-universal'
import { useOrderVolumeContext } from '../../context'
import { accept } from '../../services/order-volume.service'
import { useToastContext } from 'hooks/useToastContext'
import { formatErrorMessage } from 'utils/handle-error'
import ModalConfirmAccept from "./modal-confirm-accept"
import { useState } from "react"
import { CheckCircle } from 'components/icons/check-circle.icon'
import ButtonIcon from "components/button-icon"

const OrderVolumeAccept = ({ refresh, volumeOrdersIds, volumeOrders }) => {
  const [showAlert, setShowAlert] = useState(false);
  const { setCheckbox, setLoading } = useOrderVolumeContext();
  const { openToast } = useToastContext();

  const acceptOrder = async () => {
    setLoading(true)
    try {
      await accept(volumeOrdersIds);
      setCheckbox([])
      refresh();
      openToast(intl.get('stocks.timeline.feedback.volumeSuccessfullyAccepted'));
    } catch (error) {
      openToast(formatErrorMessage(error), 'negative')
    }
    setLoading(false)
  }

  const handleAccept = () => {
    setShowAlert(false)
    acceptOrder()
  }

  return (
    <>
      <ButtonIcon
        buttonIcon={<CheckCircle />}          
        buttonText={intl.get("volumeOrders.acceptVolumes")}
        buttonType="default"
        disabled={volumeOrdersIds.length === 0}
        onClick={() => setShowAlert(true)}
        style={{ width: '166px' }}
      />
      {showAlert &&
        <ModalConfirmAccept
          onClick={handleAccept}
          open={showAlert}
          close={() => setShowAlert(false)}
          volumeOrdersIds={volumeOrdersIds}
        />
      }
    </>
  )
}

OrderVolumeAccept.propTypes = {
  refresh: PropTypes.func.isRequired,
  volumeOrders: PropTypes.any.isRequired,
  volumeOrdersIds: PropTypes.shape({
    includes: PropTypes.func,
    length: PropTypes.number
  }).isRequired
}

export default OrderVolumeAccept
